import axios from 'axios';
import URL from '@/_url_'

axios.defaults.baseURL = URL.baseUrl;
axios.defaults.headers.post = {
    'Content-Type':'application/x-www-form-urlencoded',
};
axios.defaults.withCredentials = true;

export default axios;